
import { defineComponent, reactive } from 'vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useVuelidate from '@vuelidate/core'
import useNotifications from '@/common/composable/useNotifications'
import { requiredIf, integer } from '@vuelidate/validators'
import { authRealisation } from '@/core/realisations/auth.realisation'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'done'],
    setup(_, { emit }) {
        const state = reactive({
            is_loading: false,
            is_on_verification: true,
            //
            email: null as string | null,
            //
            hash: null as string | null,
            code: null as number | null,
            newPassword: null as string | null,
        })

        const notifications = useNotifications()

        const RestoreValidation = {
            email: { required: requiredIf(() => state.is_on_verification) },
            code: { required: requiredIf(() => !state.is_on_verification), integer },
            newPassword: { required: requiredIf(() => !state.is_on_verification) },
        }

        const v$ = useVuelidate(RestoreValidation, state)

        const sendCode = async () => {
            if (!state.email) return

            try {
                state.is_loading = true

                const response = await authRealisation.getCode(state.email)
                state.hash = response.data.hash

                v$.value.$reset()
                state.is_on_verification = false
                notifications.notify({ title: 'Код успешно отправлен на email!', type: 'success' })
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: `Ошибка получения кода`,
                })
            } finally {
                state.is_on_verification = false
                state.is_loading = false
            }
        }

        const setNewPassword = async () => {
            if (!state.hash || !state.code || !state.newPassword) return

            try {
                state.is_loading = true

                const payload = {
                    hash: state.hash,
                    code: Number(state.code),
                    newPassword: state.newPassword,
                }

                const response = await authRealisation.setNewPassword(payload)
                state.hash = response.hash

                notifications.notify({ title: 'Новый пароль установлен!', type: 'success' })
                emit('done')
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: `Ошибка установления пароля`,
                })
            } finally {
                state.is_loading = false
            }
        }

        const emitSubmit = async () => {
            v$.value.$touch()
            if (v$.value.$invalid) return

            if (state.is_on_verification) {
                await sendCode()
            } else {
                await setNewPassword()
            }
        }

        const emitCancel = () => {
            emit('cancel')
        }

        return { state, v$, emitSubmit, emitCancel }
    },
})
